export default __webpack_public_path__ + "static/media/microbes_dark.b4803dd1.jpeg";